import React from "react";
import { useSelector } from "react-redux";

const BasicInfo = () => {
  const { companyDetail } = useSelector((state) => state.company);

  return (
    <div className="overview-tab">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h5 className="overview-details-card-title fw-bold mb-0" style={{ fontSize: "18px" }}>About</h5>
      </div>
      <p className="overview-details-bio mb-4  p-2 bg-light rounded-2" style={{ fontSize: "14px", lineHeight: "1.6" }}>
        {companyDetail?.profile?.about || "No bio added yet."}
      </p>
      <div className="overview-details-list flex-grow-1">
        <div className="overview-details-row">
          <span className="overview-details-label">Company Name</span>
          <span className="overview-details-value text-dark">{companyDetail?.name || "-"}</span>
        </div>
        <div className="overview-details-row">
          <span className="overview-details-label">Tagline</span>
          <span className="overview-details-value text-dark">{companyDetail?.tagline || "-"}</span>
        </div>
        <div className="overview-details-row">
          <span className="overview-details-label">Category</span>
          <span className="overview-details-value text-dark">{companyDetail?.category?.name || "-"}</span>
        </div>
        <div className="overview-details-row">
          <span className="overview-details-label">Website</span>
          <span className="overview-details-value">
            {companyDetail?.profile?.website ? (
              <a href={companyDetail.profile.website} target="_blank" rel="noopener noreferrer" className="overview-details-link">
                {companyDetail.profile.website}
              </a>
            ) : "-"}
          </span>
        </div>
        <div className="overview-details-row">
          <span className="overview-details-label">Whatsapp</span>
          <span className="overview-details-value text-dark">{companyDetail?.profile?.whatsapp_number || "-"}</span>
        </div>
        <div className="overview-details-row">
          <span className="overview-details-label">Address</span>
          <span className="overview-details-value text-dark">{companyDetail?.profile?.address || "-"}</span>
        </div>
        <div className="overview-details-row">
          <span className="overview-details-label">City</span>
          <span className="overview-details-value text-dark">{companyDetail?.profile?.city?.name || "-"}</span>
        </div>
        <div className="overview-details-row">
          <span className="overview-details-label">State</span>
          <span className="overview-details-value text-dark">{companyDetail?.profile?.city?.state?.name || "-"}</span>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
